import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { H5 } from 'foundations-components/transitional/components/H5';
import { useHasCurrencyFormatting } from '../hooks/useHasCurrencyFormatting';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { useBoardPanelPresentationContext } from '../context/BoardPanelPresentationContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CurrencyFormatSection = () => {
  const {
    settings,
    updateDraft,
    objectTypeId
  } = useBoardPanelPresentationContext();
  const hasCurrencyFormatting = useHasCurrencyFormatting(objectTypeId);
  if (!hasCurrencyFormatting) {
    return null;
  }
  const onCurrencyFormatChange = ({
    target: {
      checked
    }
  }) => {
    updateDraft({
      currencyFormatPreferences: Object.assign({}, settings.currencyFormatPreferences, {
        isAbbreviated: checked
      })
    });
  };
  return /*#__PURE__*/_jsxs(PanelSection, {
    paddingInline: "0",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editCardsPanel.currencyFormattingSection.title"
      })
    }), /*#__PURE__*/_jsx(MultiColumn, {
      flush: true,
      children: /*#__PURE__*/_jsxs(MultiColumnGroup, {
        children: [/*#__PURE__*/_jsx(MultiColumnItem, {
          children: /*#__PURE__*/_jsx(HelpIcon, {
            alignWithText: true,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "editCardsPanel.currencyFormattingSection.helpText"
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "editCardsPanel.currencyFormattingSection.description"
            })
          })
        }), /*#__PURE__*/_jsx(MultiColumnItem, {
          children: /*#__PURE__*/_jsx(Toggle, {
            "data-test-id": "currency-format-toggle",
            size: "small",
            checked: settings.currencyFormatPreferences.isAbbreviated,
            onChange: onCurrencyFormatChange
          })
        })]
      })
    })]
  });
};
export default CurrencyFormatSection;